<template>
    <div v-if="isLoading && (data === undefined || spinnerOnReload)" class="spinner-container">
        <slot name="initial-loader">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </slot>
    </div>
    <div v-else-if="data !== undefined" class="content-container">
        <slot v-bind:data="data" v-bind:is-loading="isLoading"/>
    </div>
</template>

<script>
export default {
    name: "DataLoader",
    props: ['loader', 'spinnerOnReload'],
    data: () => ({data: undefined, isLoading: false, pending: null}),
    watch: {
        loader: {
            immediate: true,
            handler(p) {
                if (!p) {
                    this.data = null
                    return
                }

                this.pending = p
                this.isLoading = true

                p.then(async result => {
                    if (this.pending !== p) return
                    this.isLoading = false
                    if (!result.ok) return // TODO: user feedback

                    this.data = await result.json()
                })
            }
        }
    }
}
</script>

<style scoped>
.content-container {
    width: 100%;
    height: 100%;
}

.spinner-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
